import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService } from '../../services/data.service';
import { UserCacheService } from '../../services/user-cache.service';

@Component({
    selector: 'sae-account-toggle-header',
    templateUrl: './account-toggle-header.component.html',
    styleUrls: ['./account-toggle-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AccountToggleHeaderComponent implements OnInit {
  @Input() stories: any;
  constructor(private dataService: DataService, private userCacheService: UserCacheService) { }
  universitySelect: any;
  changeStoryInstance: Subscription

  ngOnDestroy() {
    if (this.changeStoryInstance) {
      this.changeStoryInstance.unsubscribe();
    }
  }

  ngOnInit(): void {
      this.changeStoryInstance = this.dataService.changeStoryInstance.subscribe(data => {
        if (data.value) {
          this.universitySelect = this.stories.find((val)=>val.label === data.value).id;
        } else {
          this.universitySelect = this.stories[0].id;
          this.makeAnnouncement(this.stories[0].id, this.stories[0].label)
        }
      })
      this.universitySelect = this.stories[0].id;
      this.makeAnnouncement(this.stories[0].id, this.stories[0].label)
  }

  storySelect(event) {
    this.makeAnnouncement(event.target.value, event.target.options[event.target.options.selectedIndex].text)
  }
   
  //observable emit for Global dropdown changed
  makeAnnouncement(id, value) {
    this.dataService.changeStory(parseInt(id), value, '');
  }

}
